// src/components/Admin/AdminLogin.js
import React, { useState, useEffect } from 'react';
import { auth } from '../../firebase';
import { signInWithEmailAndPassword, sendEmailVerification, onAuthStateChanged } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';

const AdminLogin = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [info, setInfo] = useState('');
  const [isChecking, setIsChecking] = useState(false); // チェック中かどうかのフラグ
  const navigate = useNavigate();

  useEffect(() => {
    // 認証状態の変化を監視
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user && user.emailVerified) {
        navigate('/admin');
      }
    });

    return () => unsubscribe();
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setInfo('');
    setIsChecking(false);
    try {
      // ユーザーをサインイン
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;

      // ユーザー情報をリロードして最新のemailVerified状態を取得
      await user.reload();
      const updatedUser = auth.currentUser;

      if (updatedUser.emailVerified) {
        // 認証済みの場合は即座に管理者画面へ遷移
        navigate('/admin');
      } else {
        // 未認証の場合、認証メールを送信
        await sendEmailVerification(user);
        setInfo('メールアドレスが未認証です。認証メールを送信しました。メールを確認してください。');
        setIsChecking(true); // 認証状態のチェックを開始

        // 一定間隔で認証状態をチェック
        const checkVerification = setInterval(async () => {
          const currentUser = auth.currentUser;
          if (currentUser) {
            await currentUser.reload(); // ユーザー情報をリロード
            if (currentUser.emailVerified) {
              clearInterval(checkVerification); // チェックを停止
              setInfo('メール認証が完了しました。管理者画面へ移動します。');
              navigate('/admin'); // 管理者画面に遷移
            }
          }
        }, 5000); // 5秒ごとにチェック

        // クリーンアップ関数でインターバルをクリア
        return () => clearInterval(checkVerification);
      }
    } catch (err) {
      setError('ログインに失敗しました。メールアドレスとパスワードを確認してください。');
      console.error(err);
    }
  };

  return (
    <div className="admin-login-container">
      <h2>管理者ログイン</h2>
      {error && <p className="error">{error}</p>}
      {info && <p className="info">{info}</p>}
      <form onSubmit={handleSubmit} className="admin-login-form">
        <div>
          <label>メールアドレス:</label>
          <input 
            type="email" 
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required 
          />
        </div>
        <div>
          <label>パスワード:</label>
          <input 
            type="password" 
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required 
          />
        </div>
        <button type="submit">ログイン</button>
      </form>
      {isChecking && <p>メール認証を確認しています。完了したら自動的に管理者画面へ移動します。</p>}
    </div>
  );
};

export default AdminLogin;
